import Hero from './thai/Hero';
import ServicesNew from './thai/ServicesNew';
import ToolsStrip from './thai/ToolsStrip';
import CaseStudyCarousel from './thai/CaseStudyCarousel';
import ImplementationProcess from './thai/ImplementationProcess';
import Pricing from './thai/Pricing';
import Faq from './thai/Faq';
import Contact from './thai/Contact';

// Mirror the English homepage section order, with independently localized content.
export default function ThaiHome() {
  return <><Hero /><ServicesNew /><ToolsStrip /><CaseStudyCarousel /><ImplementationProcess /><Pricing /><Faq /><Contact /></>;
}
